import { Component, EventEmitter, Input, OnInit, Output, ElementRef, OnDestroy, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CreateCoverageEntryDto, UpdateCoverageEntryDto } from '../../../../core/data/new-dtos/insurance-type.dtos';



export interface CoverageModalResult {
    action: 'save' | 'cancel';
    data?: CreateCoverageEntryDto | UpdateCoverageEntryDto;
}

@Component({
    selector: 'app-coverage-modal',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './coverage-modal.component.html',
    styleUrls: ['./coverage-modal.component.scss']
})
export class CoverageModalComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
    @Input() coverage?: { id: number; coverageCode: string; name: string; description?: string };
    @Input() isVisible = false;
    @Output() closed = new EventEmitter<CoverageModalResult>();

    form!: FormGroup;

    constructor(private fb: FormBuilder, private elementRef: ElementRef) { }

    get isEditMode(): boolean {
        return !!this.coverage;
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            coverageCode: ['', Validators.required],
            name: ['', Validators.required],
            description: ['']
        });

        if (this.coverage) {
            this.form.patchValue({
                coverageCode: this.coverage.coverageCode,
                name: this.coverage.name,
                description: this.coverage.description
            });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.form) return;

        if (changes['coverage'] || changes['isVisible']) {
            if (this.isVisible) {
                if (this.coverage) {
                    this.form.patchValue({
                        coverageCode: this.coverage.coverageCode,
                        name: this.coverage.name,
                        description: this.coverage.description
                    });
                } else {
                    this.form.reset({
                        coverageCode: '',
                        name: '',
                        description: ''
                    });
                }
            }
        }
    }

    ngAfterViewInit() {
        document.body.appendChild(this.elementRef.nativeElement);
    }

    ngOnDestroy() {
        if (this.elementRef.nativeElement && this.elementRef.nativeElement.parentNode) {
            this.elementRef.nativeElement.parentNode.removeChild(this.elementRef.nativeElement);
        }
    }

    onSave() {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        const data = {
            coverageCode: this.form.value.coverageCode,
            name: this.form.value.name,
            description: this.form.value.description
        };

        this.closed.emit({ action: 'save', data });
    }

    onCancel() {
        this.closed.emit({ action: 'cancel' });
    }

    onBackdropClick(event: MouseEvent) {
        if ((event.target as HTMLElement).classList.contains('modal')) {
            this.onCancel();
        }
    }
}
